import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import './ImageLightbox.css';

interface ImageLightboxProps {
  src: string | null;
  alt?: string;
  onClose: () => void;
}

/** 사진 클릭 시 전체 화면 확대 보기 */
function ImageLightbox({ src, alt = '확대 이미지', onClose }: ImageLightboxProps) {
  useEffect(() => {
    if (!src) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = prevOverflow;
      window.removeEventListener('keydown', onKey);
    };
  }, [src, onClose]);

  if (!src) return null;

  return createPortal(
    <div
      className="image-lightbox"
      role="dialog"
      aria-modal="true"
      aria-label="사진 확대"
      onClick={onClose}
    >
      <button type="button" className="image-lightbox__close" aria-label="닫기" onClick={onClose}>
        ×
      </button>
      <img
        className="image-lightbox__img"
        src={src}
        alt={alt}
        onClick={(e) => e.stopPropagation()}
      />
    </div>,
    document.body
  );
}

export default ImageLightbox;
